(function ($) {

  const initializeBlock = function ($block) {
    // Generate a unique session ID
    let sessionId = generateSessionId();
    let calculationResults = null;
    let userContactInfo = {
        name: "",
        company: "",
        email: ""
    };

    // Function to generate a new session ID
    function generateSessionId() {
        return Date.now().toString(36) + Math.random().toString(36).substring(2);
    }

    // Escape any special characters in values
    const escapeValue = (val) => {
        if (typeof val === 'string') {
            // Replace tabs with spaces to maintain TSV format
            // and escape any characters that might break the CGI parsing
            return val.replace(/\t/g, ' ');
        }
        return val;
    };

    console.log("Generated session ID:", sessionId);

    // Get field structure with current form values and optional contact info
    function getFieldsStructure(includeContactInfo = false, customTimestamp = null) {
        // Get timestamp - either the provided custom timestamp, from localStorage, or create a new one
        const timestamp = customTimestamp || localStorage.getItem(`timestamp_${sessionId}`) || new Date().toISOString();

        // Create base fields structure
        const fields = [
            { header: "Timestamp", value: timestamp },
            { header: "SessionID", value: sessionId },
            { header: "Name", value: includeContactInfo ? userContactInfo.name : "" },
            { header: "Company", value: includeContactInfo ? userContactInfo.company : "" },
            { header: "Email", value: includeContactInfo ? userContactInfo.email : "" },
            { header: "Number of GPUs", value: document.getElementById("numGPUs").value },
            { header: "AI Job Types", value: escapeValue(Array.from(document.querySelectorAll('input[name="job_types"]:checked')).map(cb => cb.value).join(", ")) },
            { header: "Model Types", value: escapeValue(Array.from(document.querySelectorAll('input[name="model_types"]:checked')).map(cb => cb.value).join(", ")) },
            { header: "Job Completion Time", value: document.getElementById("jobCompletionTime").value },
            { header: "Concurrent AI Jobs", value: document.getElementById("concurrentJobs").value },
            { header: "GPU Ownership", value: document.getElementById("gpuOwnership").value },
            { header: "Crashes", value: document.getElementById("crashes").value },
            { header: "Downtime (hours)", value: document.getElementById("downtime").value },
            { header: "FTE Cost", value: document.getElementById("ftecost").value },
            { header: "Checkpoint", value: document.getElementById("checkpoint").value },
            { header: "GPU Models", value: escapeValue(Array.from(document.querySelectorAll('input[name="gpu_models"]:checked')).map(cb => cb.value).join(", ")) },
            { header: "GPU Providers", value: escapeValue(Array.from(document.querySelectorAll('input[name="gpu_providers"]:checked')).map(cb => cb.value).join(", ")) },
            { header: "GPU Cost Per Hour", value: document.getElementById("gpuCostPerHour").value }
        ];

        // Add calculation results if available
        if (calculationResults) {
            fields.push(
                { header: "Infrastructure Cost", value: calculationResults.infraCost.toString() },
                { header: "People Cost", value: calculationResults.peopleCost.toString() },
                { header: "Grand Total", value: calculationResults.grandTotal.toString() },
                { header: "Annual Total", value: calculationResults.annualTotal.toString() }
            );
        }

        // Add flag for whether contact info is included
        fields.push({ header: "Has Contact Info", value: includeContactInfo ? "Yes" : "No" });

        return fields;
    }

    function calculateAndSave() {
        // Validate required fields (except GPU models and providers)

        // Define validation rules for numeric fields
        const numericValidationRules = [
            { id: "numGPUs", name: "Number of GPUs", min: 8 },
            { id: "jobCompletionTime", name: "Job time completion in weeks", min: 0.1 },
            { id: "concurrentJobs", name: "Number of concurrent AI jobs per cluster", min: 1 },
            { id: "crashes", name: "AI job crash frequency per week", min: 0.1, message: "must be greater than 0. Decimal values (e.g., 0.1) are allowed." },
            { id: "downtime", name: "Wasted time", min: 1, message: "in hours must be at least 1 hour." },
            { id: "ftecost", name: "FTE cost per incident", min: 0.01, message: "must be greater than 0." },
            { id: "gpuCostPerHour", name: "Average GPU cost per hour", min: 0.01, message: "must be greater than 0." }
        ];

        // Check if at least one job type is selected
        const jobTypesSelected = document.querySelectorAll('input[name="job_types"]:checked').length > 0;
        if (!jobTypesSelected) {
            alert("Please select at least one AI job type.");
            return;
        }

        // Check if at least one model type is selected
        const modelTypesSelected = document.querySelectorAll('input[name="model_types"]:checked').length > 0;
        if (!modelTypesSelected) {
            alert("Please select at least one model type.");
            return;
        }

        // Check all numeric fields against their validation rules
        for (const rule of numericValidationRules) {
            const element = document.getElementById(rule.id);
            const value = parseFloat(element.value);

            // Check if value exists and is a number
            if (!element.value || isNaN(value)) {
                alert(`Please enter a valid value for ${rule.name}.`);
                element.focus();
                return;
            }

            // Check minimum value constraint
            if (value < rule.min) {
                const message = rule.message || `must be at least ${rule.min}.`;
                alert(`${rule.name} ${message}`);
                element.focus();
                return;
            }
        }

        // Generate a new session ID for each calculation
        sessionId = generateSessionId();
        console.log("New calculation with session ID:", sessionId);

        // Create timestamp for this calculation and store it in localStorage
        const timestamp = new Date().toISOString();
        localStorage.setItem(`timestamp_${sessionId}`, timestamp);

        // Hide success message if visible from previous submission
        // document.getElementById("success-message").style.display = "none";
        // document.getElementById("contactForm").style.display = "block";

        // Make sure contact instructions are visible - safely check if element exists first
        const contactInstructions = document.getElementById("contact-instructions");
        if (contactInstructions) {
            contactInstructions.style.display = "block";
        }

        // Get form values
        let crashes = parseFloat(document.getElementById("crashes").value) || 0;
        let downtime = parseFloat(document.getElementById("downtime").value) || 0; // Now in hours
        let checkpoint = parseFloat(document.getElementById("checkpoint").value);
        let fteCost = parseFloat(document.getElementById("ftecost").value) || 0;
        let numGPUs = parseFloat(document.getElementById("numGPUs").value) || 1;
        let jobCompletionTime = parseFloat(document.getElementById("jobCompletionTime").value) || 1;
        let gpuCostPerHour = parseFloat(document.getElementById("gpuCostPerHour").value) || 0;

        // Calculate Infrastructure cost
        let infraCost = jobCompletionTime * crashes * downtime * gpuCostPerHour * numGPUs;

        // Calculate People cost
        let peopleCost = jobCompletionTime * crashes * fteCost;

        // Calculate Grand total
        let grandTotal = infraCost + peopleCost;

        // Calculate Annualized total (multiply by 52 weeks in a year)
        let annualTotal = grandTotal * (52 / jobCompletionTime);

        // Store calculation results for later
        calculationResults = {
            infraCost: infraCost,
            peopleCost: peopleCost,
            grandTotal: grandTotal,
            annualTotal: annualTotal
        };

        // Format and display results
        document.getElementById("infra-cost-result").innerText = "$" + infraCost.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        document.getElementById("people-cost-result").innerText = "$" + peopleCost.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        document.getElementById("grand-total-result").innerText = "$" + grandTotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        document.getElementById("annual-total-result").innerText = "$" + annualTotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // Show results container
        document.getElementById("results-display").style.display = "block";

        // Show contact form after showing results
        document.getElementById("contact-form").style.display = "block";

        // Prepopulate contact form if we have previous info
        if (userContactInfo.name) {
            document.getElementById("name").value = userContactInfo.name;
            document.getElementById("company").value = userContactInfo.company;
            document.getElementById("email").value = userContactInfo.email;
        }

        // Scroll to a position that ensures the contact form button is visible
        setTimeout(() => {
            const contactForm = document.getElementById("contact-form");
            const rect = contactForm.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = rect.top + scrollTop - 350; // Increased offset to show more of the form

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }, 100); // Short delay to ensure DOM elements are ready

        // Use the timestamp that was just stored
        const fields = getFieldsStructure(false, timestamp);

        // Create form data object
        const formData = new FormData();

        // Add the structured data to formData
        // formData.append("fieldData", JSON.stringify(fields));
        // formData.append("sessionId", sessionId);

        // // Send data to server - initial save of calculation data with new session ID
        // fetch('process_data.cgi', {
        //     method: 'POST',
        //     body: formData
        // })
        // .then(response => response.json())
        // .then(data => {
        //     // Data saved successfully, no message displayed
        //     console.log("Initial calculation data saved:", data.success ? "success" : "failed");
        // })
        // .catch(error => {
        //     // Log error to console instead of displaying it
        //     console.error("Error saving initial data:", error);
        // });
    }

    // Function to check if an email domain is a common personal/free email
    function isPersonalEmail(email) {
        // List of common free/personal email domains
        const personalDomains = [
            'gmail.com',
            'yahoo.com',
            'hotmail.com',
            'outlook.com',
            'aol.com',
            'icloud.com',
            'mail.com',
            'zoho.com',
            'protonmail.com',
            'proton.me',
            'live.com',
            'msn.com',
            'me.com',
            'yandex.com',
            'gmx.com',
            'gmx.net',
            'inbox.com',
            'mail.ru',
            'comcast.net',
            'verizon.net',
            'att.net',
            'sbcglobal.net',
            'btinternet.com'
        ];

        // Extract domain from email
        const domain = email.split('@')[1].toLowerCase();

        // Check if domain is in the personal domains list
        return personalDomains.includes(domain);
    }

    function submitContactInfo() {
        // Get contact info
        const name = document.getElementById("name").value;
        const company = document.getElementById("company").value;
        const email = document.getElementById("email").value;

        // Validate contact form
        if (!name || !company || !email) {
            alert("Please fill in all fields to receive your report.");
            return;
        }

        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            alert("Please enter a valid email address.");
            return;
        }

        // Check if it's a personal email
        if (isPersonalEmail(email)) {
            alert("Please use your corporate email address to receive the report.");
            return;
        }

        if (!calculationResults) {
            alert("Please calculate your impact first.");
            return;
        }

        // Save the user contact info for future form prepopulation
        userContactInfo = {
            name: name,
            company: company,
            email: email
        };

        // Get the original timestamp from localStorage
        const originalTimestamp = localStorage.getItem(`timestamp_${sessionId}`);

        // Get field structure with contact info and the original timestamp
        const fields = getFieldsStructure(true, originalTimestamp);

        // Create form data object
        const formData = new FormData();

        // Add the structured data to formData
        formData.append("fieldData", JSON.stringify(fields));
        formData.append("updateSession", sessionId); // Signal that this is an update

        // Send data to server
        fetch('process_data.cgi', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            // Safely hide contact instructions and heading
            const contactInstructions = document.getElementById("contact-instructions");
            if (contactInstructions) {
                contactInstructions.style.display = "none";
            }

            const contactHeading = document.getElementById("contact-heading");
            if (contactHeading) {
                contactHeading.style.display = "none";
            }

            // Show success message
            document.getElementById("success-message").style.display = "block";

            // Hide the form
            document.getElementById("contactForm").style.display = "none";
            console.log("Contact data updated:", data.success ? "success" : "failed");
        })
        .catch(error => {
            console.error("Error updating contact data:", error);
            alert("There was an error submitting your information. Please try again later.");
        });
    }

    $('#calculateAndSave').click(function(event) {
      calculateAndSave()
    });

    $('#submitContactInfo').click(function(event) {
      submitContactInfo()
    });
  }

  $(document).ready(function () {
    $('.block--gpu-calculator').each(function () {
      initializeBlock($(this));
    })
  })

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=gpu-calculator', initializeBlock);
  }

})(jQuery);
